const baseRoute = '/queueton/api';

export const queuetonAPI = {
  /**
   * @param {{ type: string, id: string }[]} resources - Resources array
   * @returns { { success: boolean, resources: { type: string, id: string, status: string }[] } }
   */
  async getStatuses(resources = []) {
    try {
      const apiResponse = await window.axios.post(baseRoute + '/statuses', { resources: resources });
      return apiResponse.data;
    } catch (e) {
      console.log(e);

      return {
        success: false, resources: []
      };
    }
  },

  async getStatus(resourceType, resourceId) {
    const now = Date.now();
    try {
      const apiResponse = await window.axios.get(`${baseRoute}/status/${resourceType}/${resourceId}?_=${now}`);
      return apiResponse.data.status;
    } catch (e) {
      console.log(e);

      return 'idle';
    }
  }
}